import * as FS from '@fullstory/browser';
import { useEffect } from 'react';
import { Config } from 'src/js/config';
import systemInfo from 'src/js/data/systemInfo';
import { constant } from 'src/js/constant';

export function useFullStory(isFSEnabled: boolean) {
  const debug = false;

  useEffect(() => {
    if (isFSEnabled && !FS.isInitialized()) {
      FS.init({ orgId: 'o-1EQT7G-na1', devMode: Config.isDebug, debug: debug }, ({ sessionUrl }) => {
        /* eslint-disable-next-line no-console */
        console.info(`Started FullStory session: ${sessionUrl}`);
        FS.setUserVars({
          product_str: constant.productName,
          environment_str: process.env.NODE_ENV,
          version_str: systemInfo.version,
          platform_str: 'web',
        });
      });
    }
  }, [isFSEnabled]);
}
